import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  SwitchFieldProps,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { DocSubmissionRepository } from '@/store/doc-submission-state/doc-submission-state.repository';
import { Observable } from 'rxjs';

interface IDocSubmissionFormObjectProps {
  store: DocSubmissionRepository;
  docSubmissionTypesOptions: Observable<SelectOption[]>;
}

export const getDocSubmissionFormObject = ({ store, docSubmissionTypesOptions }: IDocSubmissionFormObjectProps): DynamicForm => {
  const nomField: DynamicField<TextFieldProps> = {
    label: 'settings.docSubmission.form.nom.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'nom'),
    props: {
      value: store.getNestedObservable<string>('dto', 'nom'),
      onChange: (value: string) => {
        store.setNestedWithComparison('dto', 'nom', value);
        store.clearError('nom');
      },
    },
  };

  const docSubmissionTypeField: DynamicField<SelectFieldProps> = {
    label: 'settings.docSubmission.form.typeDossier.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'typeDossier'),
    props: {
      placeholder: 'settings.docSubmission.form.typeDossier.placeholder',
      options: docSubmissionTypesOptions,
      value: store.getObservable('docSubmissionCategorySelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNestedWithComparison('dto', 'typeDossierId', value.code);
        store.setWithComparison('docSubmissionCategorySelected', value);
        store.clearError('typeDossierId');
      },
    },
  };

  const isValidationDateRequiredField: DynamicField<SwitchFieldProps> = {
    label: '',
    variant: FieldVariant.SWITCH,
    error: store.getNestedObservable<string>('errors', 'validationDateRequired'),
    props: {
      checked: store.getNestedObservable<boolean>('dto', 'validationDateRequired'),
      placeholder: 'settings.docSubmission.form.validationDateRequired.placeholder',
      onChange: value => {
        store.setNestedWithComparison('dto', 'validationDateRequired', value.checked, false);
        store.clearError('validationDateRequired');
      },
    },
  };

  return {
    title: 'settings.docSubmission.form.title',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nomField],
          },
          {
            fields: [docSubmissionTypeField],
          },
          {
            fields: [isValidationDateRequiredField],
          },
        ],
      },
    ],
  };
};
